import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { AufstellungPage } from '../aufstellung/aufstellung';
import { QuickviewPage } from '../quickview/quickview';


@Component({
  selector: 'page-rahmen',
  templateUrl: 'rahmen.html',
})
export class RahmenPage {
productname: string;
producttype: string;
windowtype: string;
typeopen: string
windowlong: string;
windowwide: string;
dichtungen: string;
dekorfarbe: string;
outColorIn: string;
outColorOut: string;
selectedGriffe: string;
selectedOrnament: any; 
selectedVerglasung: any; 
selectedKante: string;
selectedSprossentyp: any;
selectedSprossenmuster: any;
selectedSprossenfarbe: any;
rahmen: any;
rahmen1: any;
selectedRahmenLinks: any;
selectedRahmenRechts: any;
selectedRahmenOben: any;
selectedRahmenUnten: any;
selectedRahmenSide: any;
noInfo: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController, public popoverCtrl: PopoverController  )  {
  
  this.noInfo = "Keine Angaben";
  
    this.selectedSprossentyp = this.navParams.get('selectedSprossentyp');
    this.selectedSprossenmuster = this.navParams.get('selectedSprossenmuster');
    this.selectedSprossenfarbe = this.navParams.get('selectedSprossenfarbe');
    this.selectedOrnament = this.navParams.get('selectedOrnament');
    this.selectedVerglasung = this.navParams.get('selectedVerglasung');
    this.selectedKante = this.navParams.get('selectedKante');
    this.selectedGriffe = this.navParams.get('selectedGriffe');
    this.dichtungen = this.navParams.get('dichtungen');
    this.outColorIn = this.navParams.get('outColorIn');
    this.outColorOut = this.navParams.get('outColorOut');
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    this.windowlong = this.navParams.get('windowlong');
    this.windowwide = this.navParams.get('windowwide');

    
  if (this.selectedSprossentyp == null || this.selectedSprossentyp == "undefined" || this.selectedSprossentyp == ''){
  this.selectedSprossentyp = this.noInfo;
  } 
  if (this.selectedSprossenmuster == null || this.selectedSprossenmuster == "undefined" || this.selectedSprossenmuster == ''){
  this.selectedSprossenmuster = this.noInfo;
  }
  if (this.selectedSprossenfarbe == null || this.selectedSprossenfarbe == "undefined" || this.selectedSprossenfarbe == ''){
  this.selectedSprossenfarbe = this.noInfo;
  }
  
      console.log( this.productname, this.producttype, this.windowtype, this.typeopen, this.windowlong, this.windowwide, this.dichtungen, this.outColorIn, this.outColorOut, this.selectedGriffe, this.selectedKante, this.selectedVerglasung, this.selectedOrnament, this.selectedSprossentyp, this.selectedSprossenfarbe, this.selectedSprossenmuster); 
  }
  
      presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype, windowtype:this.windowtype, typeopen:this.typeopen, windowlong: this.windowlong, windowwide: this.windowwide, outColorIn:this.outColorIn, outColorOut:this.outColorOut, dichtungen: this.dichtungen, selectedGriffe:this.selectedGriffe, selectedKante:this.selectedKante, selectedVerglasung:this.selectedVerglasung, selectedOrnament:this.selectedOrnament, selectedSprossenfarbe:this.selectedSprossenfarbe, selectedSprossenmuster:this.selectedSprossenmuster, selectedSprossentyp:this.selectedSprossentyp}
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 

  ionViewDidLoad() {
    console.log('ionViewDidLoad RahmenPage');
  }
  
        ionViewWillEnter() : void
   {
   // this.getRahmen();
   }
   
   
  getRahmen(){
  this.presentLoading();
  this.userService.getRahmen()
  .subscribe((data : any) =>
      { 
          this.rahmen = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });    
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getRahmen();
   refresher.complete();
   }
   

  selectedRahmen(rahmen){ 
  if (rahmen == "links") {
   this.selectedRahmenSide= rahmen;
   this.getRahmen();
  } if (rahmen == "rechts") {
    this.selectedRahmenSide = rahmen;
    this.getRahmen();
  } if (rahmen == "oben") {
    this.selectedRahmenSide = rahmen;
    this.getRahmen();
  }
    if (rahmen == "unten") {
    this.selectedRahmenSide = rahmen;
    this.getRahmen();
  }      
}

  selectedRahmenType(rahmen) {
   if (this.selectedRahmenSide == "links") {
   this.selectedRahmenLinks= rahmen;
   this.rahmen = null;
  } if (this.selectedRahmenSide == "rechts") {
    this.selectedRahmenRechts = rahmen;
   this.rahmen = null;
  } if (this.selectedRahmenSide == "oben") {
    this.selectedRahmenOben = rahmen;
   this.rahmen = null;
  }
    if (this.selectedRahmenSide == "unten") {
    this.selectedRahmenUnten = rahmen;
   this.rahmen = null;
  }      
  }
  
  
   clickrahmen(selectedRahmenLinks, selectedRahmenRechts, selectedRahmenOben, selectedRahmenUnten) {
    this.navCtrl.push(AufstellungPage, { 
    selectedRahmenLinks: selectedRahmenLinks,
    selectedRahmenRechts: selectedRahmenRechts,
    selectedRahmenOben: selectedRahmenOben,
    selectedRahmenUnten: selectedRahmenUnten,
    selectedSprossentyp: this.selectedSprossentyp,
    selectedSprossenfarbe: this.selectedSprossenfarbe,
    selectedSprossenmuster: this.selectedSprossenmuster,
    selectedVerglasung: this.selectedVerglasung,
    selectedKante: this.selectedKante,
    selectedOrnament: this.selectedOrnament,
    selectedGriffe: this.selectedGriffe,
    dichtungen: this.dichtungen,
    outColorIn: this.outColorIn,
    outColorOut: this.outColorOut,
    typeopen: this.typeopen,
    windowtype: this.windowtype,
    productname: this.productname,
    producttype: this.producttype,
    windowlong: this.windowlong,
    windowwide: this.windowwide
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/rahmen/rahmen.ts